import { render, staticRenderFns } from "./Formset.vue?vue&type=template&id=4c94765c&scoped=true"
import script from "./Formset.vue?vue&type=script&lang=js"
export * from "./Formset.vue?vue&type=script&lang=js"
import style0 from "./Formset.vue?vue&type=style&index=0&id=4c94765c&prod&lang=scss&scoped=true"
import style1 from "./Formset.vue?vue&type=style&index=1&id=4c94765c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94765c",
  null
  
)

export default component.exports